import { types } from 'mobx-state-tree';

const OrderCheckoutType = {
  B2C: 'B2C',
  B2B: 'B2B',
};

export default OrderCheckoutType;

export const OrderCheckoutTypeType = types.enumeration(
  'OrderCheckoutTypeType',
  Object.values(OrderCheckoutType)
);
